import * as React from 'react';
import { SubtotalRow } from './Partials/SubtotalRow/SubtotalRow';
import s from './Totals.scss';
import { TotalRow } from './Partials/TotalRow/TotalRow';
import { SummeryDivider } from './Partials/SummeryDivider/SummeryDivider';
export var TotalsDataHook;
(function (TotalsDataHook) {
    TotalsDataHook["TotalsTable"] = "totals-table";
    TotalsDataHook["TotalsRow"] = "total-row";
    TotalsDataHook["TotalsRowTitle"] = "total-row-title";
    TotalsDataHook["TotalsRowValue"] = "total-row-value";
    TotalsDataHook["TotalsRowSecondaryValue"] = "total-row-secondary-value";
    TotalsDataHook["SubtotalsRow"] = "subtotal-row";
    TotalsDataHook["SubtotalsRowTitle"] = "subtotal-row-title";
    TotalsDataHook["SubtotalsRowValue"] = "subtotal-row-value";
    TotalsDataHook["SummaryDivider"] = "summery-divider";
})(TotalsDataHook || (TotalsDataHook = {}));
export var Totals = function (_a) {
    var children = _a.children;
    var flattenedChildren = children.reduce(function (accumulator, currentValue) { return accumulator.concat(currentValue); }, []);
    var validChildren = flattenedChildren.filter(function (child) { var _a; return (_a = child === null || child === void 0 ? void 0 : child.type) === null || _a === void 0 ? void 0 : _a.displayName; });
    var subtotalRows = validChildren.filter(function (child) { return child.type.displayName === Totals.SubtotalRow.displayName; });
    var totalRow = validChildren.filter(function (child) { return child.type.displayName === Totals.TotalRow.displayName; });
    var summeryDivider = validChildren.filter(function (child) { return child.type.displayName === Totals.SummeryDivider.displayName; });
    return (React.createElement("div", { "data-hook": TotalsDataHook.TotalsTable, className: s.totalsWrapper },
        React.createElement("table", { className: s.tableWrapper },
            React.createElement("tbody", null, subtotalRows)),
        summeryDivider,
        React.createElement("table", { className: s.tableWrapper },
            React.createElement("tbody", null, totalRow))));
};
Totals.displayName = 'Totals';
Totals.SubtotalRow = SubtotalRow;
Totals.TotalRow = TotalRow;
Totals.SummeryDivider = SummeryDivider;
//# sourceMappingURL=Totals.js.map